import React from "react";
import Layout from "Layout";
import Section from "Layout/Section";
import BulkBundleCreation from "components/BulkBundleUtility/index";

const CreateBulkCampaign = () => {
  return (
    <Layout>
      <Section>
        <BulkBundleCreation />
      </Section>
    </Layout>
  );
};

export default CreateBulkCampaign;
